import { AppRequestsKindEnum } from 'src/graphql/schema';

import { VendorRequestsFilter } from './types';

export const PER_PAGE = 20;

export const KIND_BY_FILTER: Record<VendorRequestsFilter, AppRequestsKindEnum> = {
  received: AppRequestsKindEnum.Received,
  sent: AppRequestsKindEnum.Sent,
  declined: AppRequestsKindEnum.Declined,
};
